import { Shark, Utils } from "shark-mvc";
import moment from "moment-timezone";

import NousCoreModel from "./NousCoreModel";
import OrganizationMembership from "./OrganizationMembership";

class Project extends NousCoreModel {
	static STATUS_CLOSED = 7;
	static STATUS_RUNNING = 1;
	static STATUS_PAUSED = 3;

	static VALUATION_AMOUNT_PER_CUSTOMER = 2;
	static VALUATION_AMOUNT_PER_USER = 1;
	static VALUATION_FIXED_DURATION = 4;
	static VALUATION_FIXED_VALUE = 3;

	activityColor = "color-0"; // Join field
	clientGuid = "";
	clientName = "";
	description = "";
	endDate = "0000-00-00 00:00:00";
	fixedDuration = 0;
	fixedValue = 0;
	isActive = false; // Buttare
	lastActivityAt = "0000-00-00 00:00:00";
	name = "";
	organizationGuid = "";
	ownerGuid = "";
	startDate = "0000-00-00 00:00:00";
	tags = [];
	taskList = [];
	taskCount = 0;
	userGuid = "";
	userLastActivityAt = "0000-00-00 00:00:00";
	userLastActivityAtGuid = "";
	userList = [];
	valuationType = 0;

	// __cssClasses = new Set();
	// __cssClassesString = "";
	__customerLabel = "";
	__currUserCanChangePermission = false;
	__currUserCanSeeProjectCustomerField = false;
	__currUserCanSeeProjectEconomicField = false;
	__currUserCanEdit = false;
	__currUserIsOwner = false;
	//__createdAtLabel = ""; //ALICE WAS HERE // Alice: chiedi a Dave perché ha tolto questo riga
	__fixedDurationDisplay = "";
	__fixedValueDisplay = "";
	__hasFixedDuration = false;
	__hasFixedValue = false;
	__isRunningWorkSessionProject = false;
	__lastActivityAt = "0000-00-00 00:00:00";
	__ownerInitials = "";
	__ownerName = "";
	__ownerPictureURL = "";
	__selected = false;
	__tagsString = "";
	__useCustomerFixedAmount = false;
	__userLastActivityAt = "0000-00-00 00:00:00";
	__valuationTypeLabel = "";
	__visible = true;
		
	constructor (data) {
		super(data, "Project");

		this.status = 1;
		
		if (this.__renderer) {
			this.__renderer.__cssClasses = new Set();
			this.__renderer.__cssClassesString = "";

			this.__renderer.cssClasses = () => {
				return this.__renderer.__cssClassesString;
			};

			this.__renderer.addClasses = (...classes) => {
				if (!Array.isArray(classes)) {
					classes = [classes];
				}

				classes.forEach(item => this.__renderer.__cssClasses.add(item));
				this.__renderer.flattenCSSClasses();
			};
	
			this.__renderer.removeClasses = (...classes) => {
				if (!Array.isArray(classes)) {
					classes = [classes];
				}

				classes.forEach(item => this.__renderer.__cssClasses.delete(item));
				this.__renderer.flattenCSSClasses();
			};

			this.__renderer.flattenCSSClasses = () => {
				this.__renderer.__cssClassesString = [...this.__renderer.__cssClasses].map(item => item + " ").join("");
			};

		}
		
		if (data) {
			this.import(data);
		}
		
		this.__renderer.addClasses(`status-${this.status}`);
	}

	export () {
		const exportData = super.export();

		exportData.endDate = this.exportDateField("endDate");
		exportData.startDate = this.exportDateField("startDate");
		exportData.tags = this.exportArrayField("tags");

		exportData.taskList = this.exportArrayField("taskList");
		exportData.userList = this.exportArrayField("userList");
				
		return exportData;
	}

	getDuration () {
		const durationMS = this.taskList.reduce((a, b) => {
			return a + b.__duration;
		}, 0);
		const internalCost = this.taskList.reduce((a, b) => {
			return a + b.__internalCost;
		}, 0);
		const externalCost = this.taskList.reduce((a, b) => {
			return a + b.__externalCost;
		}, 0);

		const duration = moment.duration(durationMS);
		this.__durationLabel = duration.format("HH:mm:ss", { trim: false });

		// this.__durationLabel = moment(duration).utc().format("HH:mm:ss");
		this.__internalCost = internalCost;
		this.__internalCostLabel = Shark.$store.moneyFormatter.format(this.__internalCost);

		this.__externalCost = externalCost;
		this.__externalCostLabel = Shark.$store.moneyFormatter.format(this.__externalCost);

		const multipliedDuration = this.taskList.reduce((a, b) => {
			return a + b.__multipliedDuration;
		}, 0);
		const multipliedExternalCost = this.taskList.reduce((a, b) => {
			return a + b.__multipliedExternalCost;
		}, 0);
		this.__multipliedDuration = multipliedDuration;
		// this.__multipliedDurationLabel = moment.duration(multipliedDuration).format("HH:mm:ss", { trim: false });
		this.__userMultipliedExternalCost = multipliedExternalCost;
		this.__userMultipliedExternalCostLabel = Shark.$store.moneyFormatter.format(this.__userMultipliedExternalCost);

		this.__invoiceValue = this.taskList.reduce((a, b) => {
			return a + b.__invoiceValue;
		}, 0);
		this.__invoiceValueLabel = Shark.$store.moneyFormatter.format(this.__invoiceValue);

		return durationMS;
	}

	// Dave: Ma se questa cosa diventasse una roba standard del "renderer"??
	// flattenCSSClasses () {
	// 	this.__cssClassesString = [...this.__cssClasses].map(item => item + " ").join("");
	// 	// this.__cssClasses.forEach(item => this.__cssClassesString += " " + item);
	// }

	import (data, options) {
		super.import(data, options);

		if (!data.clientName) {
			this.clientName = "";
		}

		// this.importBooleanField("closed", data.closed);
		this.importDateField("endDate", data.endDate);
		this.importNumberField("fixedDuration", data.fixedDuration);
		this.importNumberField("fixedValue", data.fixedValue);
		this.importNumberField("valuationType", data.valuationType);

		// if (this.closed) {
		// 	this.__renderer.addClasses("closed", "list-group-item-danger");
		// 	// this.__cssClasses.add("closed");
		// 	// this.__cssClasses.add("list-group-item-danger");
		// }
		// else {
		// 	this.__renderer.removeClasses("closed", "list-group-item-danger");
		// 	// this.__cssClasses.delete("closed");
		// 	// this.__cssClasses.delete("list-group-item-danger");
		// }
		this.__tagsString = this.tags.join(", ");

		this.parseDates(data);
		this.parseCustomerName();
		this.parseOrganization();
		this.parseOwner();
		this.parseStatus();
		this.parseUserProjectPermissions();
		// this.flattenCSSClasses();

		

		if (this.activityColor === "" && Shark.$store.organizationList) {
			const organization = Shark.$store.organizationList.find(item => this.organizationGuid === item.guid);

			if (organization) {
				this.activityColor = organization.activityColor;
			}
		}

		this.parseValuationType();
	}

	onClientGuidChanged () {
		this.parseCustomerName();
	}

	onDataChanged (data) {
		switch (data.property) {
			case "__tagsString":
				// console.log("onDataChanged", data, this);
				this.tags = data.newValue.split(",").map(item => item.trim());
				// console.log(this.tags, this[data.property], data, this);
				break;
		}
	}

	onOrganizationGuidChanged () {
		// console.log("onOrganizationGuidChanged");

		const { clientList } = Shark.get();
		const newProjectClientList = clientList.filter(item => item.organizationGuid === this.organizationGuid);

		Shark.set({
			newProjectClientList,
		});

		this.parseOrganization();
	}

	onStatusChanged () {
		// console.log("onStatusChanged");
		this.parseStatus();
	}

	// Dave: Ma questa roba fa schifo!?
	// on__statusLabelChanged () {
	// 	this.parseStatus();
	// }

	onUserLastActivityAtChanged () {
		this.parseUserLastActivityAt();
	}

	onValuationTypeChanged () {
		this.parseValuationType();
	}

	parseCustomerName () {
		const { clientList } = Shark.get();

		if (clientList) {
			const client = Utils.safp(clientList, "guid", this.clientGuid);

			if (client) {
				this.clientName = client.name;
			}
		}
	}

	parseDates (data) {
		// if (this.importDateField("createdAt", data.createdAt)) {
		// 	this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY");
		// }
		
		if (this.importDateField("lastActivityAt", data.lastActivityAt)) {
			this.__lastActivityAt = this.lastActivityAt.format("YYYY-MM-DD HH:mm:ss");
			this.__lastActivityAtLabel = this.lastActivityAt.format("DD/MM/YYYY - HH:mm");
		}
		
		this.importDateField("startDate", data.startDate);
		this.parseUserLastActivityAt();
	}

	parseOrganization () {
		const { organizationList } = Shark.get();

		if (organizationList) {
			const organization = Utils.safp(organizationList, "guid", this.organizationGuid);

			if (organization) {
				this.__organizationLabel = organization.name;
			}
		}
	}

	parseOwner () {
		const owner = Utils.safp(Shark.$store.allUserList, "guid", this.ownerGuid);

		if (owner) {
			this.__ownerInitials = owner.__initials;
			// Dave. questo probabilmente dovrebbe essere il nome dell'Utente nell'organizzazione.
			this.__ownerName = owner.__fullName;
			this.__ownerPictureURL = owner.pictureURL;
		}

		this.__currUserIsOwner = this.ownerGuid === Shark.$store.currUser.guid;
		this.__currUserCanChangePermission = this.ownerGuid === Shark.$store.currUser.guid;
		this.__currUserCanEdit = this.ownerGuid === Shark.$store.currUser.guid;
	}

	parseStatus () {
		const statusObj = Shark.$store.projectStatusMap.find(item => item.id === this.status);

		if (statusObj) {
			this.set({
				// closed: this.status === Project.STATUS_CLOSED, //Questa è calcolata, dovrebbe essere una __
				__statusIcon: statusObj.icon,
				__statusLabel: statusObj.label,
			});
			
			this.clean([/*"closed",*/ "__statusIcon", "__statusLabel"]);
		}

		if (this.status === Project.STATUS_CLOSED) {
			this.__renderer.addClasses("closed", "list-group-item-danger");
		}
		else {
			this.__renderer.removeClasses("closed", "list-group-item-danger");
		}

		// Shark.render();
	}

	parseUserProjectPermissions () {
		if (Shark.$store.organizationMembershipList) {
			const projectOrganizationRole = Shark.$store.organizationMembershipList.find(item => item.organizationGuid === this.organizationGuid);

			if (projectOrganizationRole) {
				this.__currUserCanChangePermission = [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				
				this.__currUserCanEditProject = [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				this.__currUserCanEditProjectGenericField = [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				this.__currUserCanEditProjectCustomerField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				this.__currUserCanEditProjectOrganizationField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				this.__currUserCanEditProjectEconomicField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				
				this.__currUserCanDeleteProject = [OrganizationMembership.ROLE_OWNER].includes(projectOrganizationRole.role);
				
				this.__currUserCanSeeProjectEconomicField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
				this.__currUserCanSeeProjectCustomerField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(projectOrganizationRole.role);
			}
			else // starter
			{
				this.__currUserCanChangePermission = false;

				this.__currUserCanEditProject = true;
				this.__currUserCanEditProjectGenericField = true;
				this.__currUserCanEditProjectCustomerField = false;
				this.__currUserCanEditProjectOrganizationField = false;
				this.__currUserCanEditProjectEconomicField = false;

				this.__currUserCanDeleteProject = true;
				
				this.__currUserCanSeeProjectEconomicField = false;
				this.__currUserCanSeeProjectCustomerField = false;
			}
		}
	}

	parseUserLastActivityAt () {
		if (this.importDateField("userLastActivityAt", this.userLastActivityAt)) {
			// Dave: uno di questi due qui sotto è duplicato e inutile
			this.__userLastActivityAt = this.userLastActivityAt.format("YYYY-MM-DD HH:mm:ss");
			this.__lastActivityAt = this.__userLastActivityAt;
			this.__userLastActivityAtLabel = this.userLastActivityAt.format("DD/MM/YYYY HH:mm");
		}
	}

	parseValuationType() {
		switch (this.valuationType) {
			case Project.VALUATION_AMOUNT_PER_CUSTOMER:
				this.__valuationTypeLabel = "Importo orario del Cliente";

				if (this.clientGuid) {
					const customer = Utils.safp(Shark.$store.clientList, "guid", this.clientGuid);

					if (customer) {
						this.__customerHourlyCost = customer.fixedHourlyValue;
					}
				}
				break;
			case Project.VALUATION_AMOUNT_PER_USER:
				this.__valuationTypeLabel = "Importo orario per Utente";
				break;
			case Project.VALUATION_FIXED_DURATION:
				this.__valuationTypeLabel = "Durata fissa (H)";
				break;
			case Project.VALUATION_FIXED_VALUE:
				this.__valuationTypeLabel = "Importo fisso (€)";
				break;
		}

		this.__hasFixedDuration = this.valuationType === Project.VALUATION_FIXED_DURATION;
		this.__hasFixedValue = this.valuationType === Project.VALUATION_FIXED_VALUE;
		this.__useCustomerFixedAmount = this.valuationType === Project.VALUATION_AMOUNT_PER_CUSTOMER;

		// this.__hasFixedDuration = this.fixedDuration > 0;
		// this.__hasFixedValue = this.fixedValue > 0;
	
		if (this.__hasFixedDuration) {
			this.__fixedDurationDisplay = `<div class="badge bg-info mb-1">H</div>`;
		}
		if (this.__hasFixedValue) {
			this.__fixedValueDisplay = `<div class="badge bg-info mb-1">€</div>`;
		}
		
	}

	validate () {
		let errors = [];

		errors = errors.concat(this.validatName());
		errors = errors.concat(this.validatOrganizationGuid());

		return errors;
	}

	validatName () {
		let error = [];

		if (this.name.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_project_name,
				field: "name",
			});
		}
		return error;
	}


	validatOrganizationGuid () {
		let error = [];

		if (this.__currUserCanEditProjectOrganizationField && this.organizationGuid.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_select_an_organization,
				field: "organizationGuid",
			});
		}
		return error;
	}
}

Shark.registerModel("Project", Project);

export default Project;
